import { FormFieldBase } from './form-field-base';
import { FormGroup } from '@angular/forms';

export class FormFieldCheckbox extends FormFieldBase<boolean> {
  controlType = 'input';
  type = 'checkbox';

  constructor(options: {} = {}) {
    super(options);
    this.value = !!this.value;
  }

  onChange(event: Event, form: FormGroup): void {
    const element = event.target as HTMLInputElement;
    form.get(this.key)?.patchValue(element.checked);
  }
}
